import { render } from "./AddressAutocomplete.vue?vue&type=template&id=ba1a2f9e&scoped=true"
import script from "./AddressAutocomplete.vue?vue&type=script&lang=js"
export * from "./AddressAutocomplete.vue?vue&type=script&lang=js"

import "./AddressAutocomplete.vue?vue&type=style&index=0&id=ba1a2f9e&scoped=true&lang=css"

import exportComponent from "../../../client-postcards/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba1a2f9e"]])

export default __exports__